import { render } from "./_Footer.vue?vue&type=template&id=61ec0038&scoped=true"
import script from "./_Footer.vue?vue&type=script&lang=js"
export * from "./_Footer.vue?vue&type=script&lang=js"

import "./_Footer.vue?vue&type=style&index=0&id=61ec0038&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61ec0038"

export default script